import React from 'react';
import Modal from '@modules/layout/modal';
import Button from '@elements/button';
import { BsX } from 'react-icons/bs';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/router';

interface RemoveItemToWishlistModalProps {
    isOpen: boolean;
    onClose: () => void;
    productName?: string;
    onAddToWishlist: () => void;
    onCancel: () => void;
    isLoading?: boolean;
}

const RemoveItemsToWishlistModal: React.FC<RemoveItemToWishlistModalProps> = ({
    isOpen,
    onClose,
    productName,
    onAddToWishlist,
    onCancel,
    isLoading = false,
}) => {




    const t = useTranslations();
    const { locale } = useRouter();

    if (!isOpen) return null;

    return (
        <Modal open={isOpen} onClose={onClose} cancelable={true}>
            <div dir={locale?.startsWith('ar-') ? 'rtl' : 'ltr'} className="w-screen md:max-w-[450px] min-h-[280px] h-max bg-white rounded-3xl md:rounded-b-3xl rounded-b-none p-6 overflow-x-hidden flex flex-col justify-between">
                <div className="w-full flex items-center justify-between mb-4">
                    <h2 className="text-lg font-semibold text-[#333] flex-grow text-center pr-6">
                        {t('Add to Wishlist')}
                    </h2>
                </div>

                <p className="text-sm text-gray-700 mb-6 leading-relaxed px-2 text-center">
                    {productName && t("add_removed_item_to_wishlist_for_later_txt").replace("@", productName)}
                    {!productName && t("add_to_wishlist_for_later_txt")}
                </p>

                <div className="flex flex-col sm:flex-row space-y-3 sm:space-y-0 sm:space-x-4 w-full px-2 gap-4 items-center">
                    <Button
                        onClick={onCancel}
                        theme='lightBlue'
                        className="w-full rounded-full py-3 text-base font-semibold"
                        isDisabled={isLoading}
                    >
                        {t("Cancel")}
                    </Button>

                    <Button
                        onClick={onAddToWishlist}
                        className="w-full h-fit rounded-full md:!py-2 font-semibold text-wrap leading-tight"
                        isDisabled={isLoading}
                    >
                        {t("Add to Wishlist")}
                    </Button>

                </div>
            </div>
        </Modal>
    );
};

export default RemoveItemsToWishlistModal;
